module.exports = __webpack_public_path__ + "img/agreement_min.831c2b62.jpg";